import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dashboard,
  settings,
  Product,
  Users1,
  Vehicle,
  Wrench,
  calendar,
  Employee,
  Suppliers,
  Home,
  Sales1,
  GiftCard,
  Email,
  Receiving,
  Expense,
  Places,
} from "../../../common/imagePath";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import Header from "./Header";
import { checkUserPermission } from "../../../common/UserPermission";

const Sidebar = () => {
  const [isSideMenu, setSideMenu] = useState("");
  const [sidepromo, setSidePromo] = useState("");
  // const [path, setPath] = useState("");
  const history = useNavigate();

  const toggleSidebar = (value) => {
    setSideMenu(value);
  };

  const toggleSidebarpromo = (value) => {
    setSidePromo(value);
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const pageRefresh = (url, page) => {
    history.push(`/${url}/${page}`);
    window.location.reload();
  };

  const navigate = useNavigate();

  // const role = localStorage.getItem("Role");

  const location = useLocation();
  let pathname = location.pathname;
  console.log(pathname);

  useEffect(() => {
    // console.log("getUserPermission sidebar :=>", userPermission);

    // Temporary comment by Chelsi about header top menu  (29-12-2022)
    // document.querySelector(".main-wrapper").classList.remove("slide-nav");
    // document.querySelector(".sidebar-overlay").classList.remove("opened");
    // document.querySelector(".sidebar-overlay").onclick = function () {
    //   this.classList.remove("opened");
    //   document.querySelector(".main-wrapper").classList.remove("slide-nav");
    // };

    const element = document.querySelector(".main-wrapper");
    if (element !== null) {
      element.classList.remove("slide-nav");
      document.querySelector(".sidebar-overlay").classList.remove("opened");
      document.querySelector(".sidebar-overlay").onclick = function () {
        this.classList.remove("opened");
        document.querySelector(".main-wrapper").classList.remove("slide-nav");
      };
    }
  }, [pathname]);

  const redirectToreceiving = () => {
    // localStorage.setItem("receivingDraft", {openpageexpenses:true});
    localStorage.setItem("openpageexpenses", true);
    // navigate("/manage-receiving");
    // return ("/manage-receiving");
  };

  let customerid = localStorage.getItem("CustomerId");
  let iscustomer = localStorage.getItem("IsCustomer");

  console.log(iscustomer,"iscustomer");

  return (
    <>
      <Header />
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              {(iscustomer == 0 ||  iscustomer==null ||  iscustomer==undefined)? (
                <ul>
                  {checkUserPermission("/dashboard") ? (
                    <li
                      className={pathname.includes("dashboard") ? "active" : ""}
                    >
                      <Link
                        to="/dashboard"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img src={Dashboard} alt="img" />
                        <span>Dashboard</span>
                      </Link>
                    </li>
                  ) : null}

                  {/* Transaction log 26-10-2023 */}
                  {checkUserPermission("/transaction-log") ? (
                    <li>
                      <Link
                        className={
                          pathname.includes("transaction-log") ||
                          pathname.includes("/transaction-log")
                            ? "active"
                            : ""
                        }
                        to="/transaction-log"
                      >
                        <img
                          src={Product}
                          alt="img"
                          style={{ width: "18px" }}
                        />
                        <span>Transaction Log</span>
                      </Link>
                    </li>
                  ) : null}

                  {/* Items 26-10-2023 */}
                  {checkUserPermission("/items") ? (
                    <li>
                      <Link
                        className={pathname.includes("items") ? "active" : ""}
                        to="/items"
                      >
                        <img src={Product} alt="img" />
                        <span> Items </span>
                      </Link>
                    </li>
                  ) : null}
                  {/*Customers*/}
                  {checkUserPermission("/customers") ? (
                    <li
                      className={
                        pathname.includes("customers") ||
                        pathname.includes("/manage-customers") ||
                        pathname.includes("/deleted-customers") ||
                        pathname.includes("/customer-intake-form") ||
                        pathname.includes("/import-excel-customers") ||
                        pathname.includes("/customer-barcode-label") ||
                        pathname.includes("/custom-field-configuration")
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to="/customers"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img src={Users1} alt="img" />
                        <span>Customers</span>
                      </Link>
                    </li>
                  ) : null}

                  {/*Suppliers*/}
                  {checkUserPermission("/suppliers") ? (
                    <li
                      className={
                        pathname.includes("suppliers") ||
                        pathname.includes("/manage-suppliers") ||
                        pathname.includes("/deleted-suppliers") ||
                        pathname.includes("/import-excel-suppliers") ||
                        pathname.includes(
                          "/custom-field-suppliers-configuration"
                        )
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to="/suppliers"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img
                          src={Suppliers}
                          alt="img"
                          style={{ width: "18px" }}
                        />
                        <span>Suppliers</span>
                      </Link>
                    </li>
                  ) : null}

                  {checkUserPermission("/receiving") ||
                  checkUserPermission("/manage-receiving") ||
                  checkUserPermission("/manage-receiving/:id") ||
                  checkUserPermission("/receiving-paybills") ? (
                    <li className="submenu">
                      <a
                        className={
                          pathname.includes("/receiving") ||
                          pathname.includes("/manage-receiving")
                            ? "active subdrop"
                            : "" || pathname.includes("/receiving-paybills")
                            ? "active subdrop"
                            : "" ||
                              pathname.includes("/receiving-barcode-label")
                            ? "active subdrop"
                            : "" || isSideMenu == "receiving"
                            ? "subdrop active"
                            : ""
                        }
                        onClick={() =>
                          toggleSidebar(
                            isSideMenu == "receiving" ? "" : "receiving"
                          )
                        }
                      >
                        <img src={Sales1} alt="img" />
                        <span> Receiving </span> <span className="menu-arrow" />
                      </a>
                      {isSideMenu == "receiving" ? (
                        <ul className="sidebar-ul">
                          {checkUserPermission("/receiving") && (
                            <li>
                              <Link
                                className={
                                  pathname.includes("receiving") ||
                                  pathname.includes("/receiving")
                                    ? "active"
                                    : ""
                                }
                                to="/receiving"
                              >
                                Receiving List
                              </Link>
                            </li>
                          )}
                          {checkUserPermission("/manage-receiving") && (
                            <li>
                              <Link
                                className={
                                  pathname.includes("manage-receiving") ||
                                  pathname.includes("/manage-receiving")
                                    ? "active"
                                    : ""
                                }
                                to="/manage-receiving"
                              >
                                Add New Receiving
                              </Link>
                            </li>
                          )}
                          {checkUserPermission("/receiving-paybills") && (
                            <li>
                              <Link
                                className={
                                  pathname.includes("receiving-paybills") ||
                                  pathname.includes("/receiving-paybills")
                                    ? "active"
                                    : ""
                                }
                                to="/receiving-paybills"
                              >
                                Pay Bills
                              </Link>
                            </li>
                          )}
                        </ul>
                      ) : (
                        ""
                      )}
                    </li>
                  ) : null}

                  {checkUserPermission("/sales") ? (
                    <li className="submenu">
                      <a
                        className={
                          pathname.includes("/sales") ||
                          pathname.includes("/manage-sales")
                            ? "active subdrop"
                            : "" || pathname.includes("/receive-payment")
                            ? "active subdrop"
                            : "" || isSideMenu == "sales"
                            ? "subdrop active"
                            : ""
                        }
                        onClick={() =>
                          toggleSidebar(isSideMenu == "sales" ? "" : "sales")
                        }
                      >
                        <img src={Sales1} alt="img" />
                        <span> Sales </span> <span className="menu-arrow" />
                      </a>
                      {isSideMenu == "sales" ? (
                        <ul className="sidebar-ul">
                          <li>
                            <Link
                              className={
                                pathname.includes("sales") ||
                                pathname.includes("/sales")
                                  ? "active"
                                  : ""
                              }
                              to="/sales"
                            >
                              Sales List
                            </Link>
                          </li>

                          <li>
                            <Link
                              className={
                                pathname.includes("manage-sales") ||
                                pathname.includes("/manage-sales")
                                  ? "active"
                                  : ""
                              }
                              to="/manage-sales"
                            >
                              Add New Sale
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={
                                pathname.includes("receive-payment") ||
                                pathname.includes("/receive-payment")
                                  ? "active"
                                  : ""
                              }
                              to="/receive-payment"
                            >
                              Receive Payments
                            </Link>
                          </li>
                        </ul>
                      ) : (
                        ""
                      )}
                    </li>
                  ) : null}

                  {/* Job Work  27-10-2023 */}
                  {checkUserPermission("/jobworks") ? (
                    <li
                      className={
                        pathname.includes("jobworks") ||
                        pathname.includes("/manage-jobworks") ||
                        pathname.includes("/manage-jobworks/:id") 
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to="/jobworks"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img src={Users1} alt="img" style={{ width: "18px" }} />
                        <span>Job Works</span>
                      </Link>
                    </li>
                  ) : null}

                  {checkUserPermission("/jobapprove") ? (
                    <li
                      className={
                        pathname.includes("/jobapprove") ? "active" : ""
                      }
                    >
                      <Link
                        to="/jobapprove"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img src={Users1} alt="img" style={{ width: "18px" }} />
                        <span>Job Request</span>
                      </Link>
                    </li>
                  ) : null}

                  {/* Employees  */}

                  {checkUserPermission("/employees") ? (
                    <li
                      className={
                        pathname.includes("/employees") ||
                        pathname.includes("/manage-employee") ||
                        pathname.includes(
                          "/custom-field-employee-configuration"
                        ) ||
                        pathname.includes("/manage-permissions")
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to="/employees"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img
                          src={Employee}
                          alt="img"
                          style={{ width: "18px" }}
                        />
                        <span>Employees</span>
                      </Link>
                    </li>
                  ) : null}

                  {/* Report */}

                  {checkUserPermission("/reports") ? (
                    <li
                      className={
                        pathname.includes("report") ||
                        pathname.includes("/report")
                          ? // pathname.includes("/Customer-Balance-Summary") ||
                            // pathname.includes("/expense-report") ||
                            // pathname.includes("/customer-contact-list") ||
                            // pathname.includes("/sales-by-customer-detail") ||
                            // pathname.includes("/sales-by-customer-type-detail") ||
                            // pathname.includes("/transaction-list-by-customer")  ||
                            // pathname.includes("/sales-by-customer-summary-report") ||
                            // pathname.includes("/vendor-balance-summary") ||
                            // pathname.includes("/expenses-by-vendor-summary") ||
                            // pathname.includes("/open-purchase-order-list") ||
                            // pathname.includes("/transaction-list-by-vendor")
                            "active"
                          : ""
                      }
                    >
                      <Link
                        to="/reports"
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img src={Sales1} alt="img" />
                        <span>Reports</span>
                      </Link>
                    </li>
                  ) : null}
                </ul>
              ) : (
                <ul>
                  {/*Manage-Customers 1-11-2023 OmishJarkan*/}
                  {checkUserPermission("/manage-customers/:id") ? (
                    <li
                      className={
                        pathname.includes("/manage-customers/:id")
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={`/manage-customers/${customerid}`}
                        onClick={() =>
                          toggleSidebar(isSideMenu == "" ? "" : "")
                        }
                      >
                        <img src={Users1} alt="img" />
                        <span>Customers</span>
                      </Link>
                    </li>
                  ) : null}
                </ul>
              )}
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
